"use strict";
var Ajaxinate = function(t) {
    var e = t || {};
    this.settings = Object.assign({
        pagination: "#pagination-wrapper",
        method: "scroll",
        container: "#product-grid",
        offset: 0,
        loadingText: "Loading...",
         async: true,
        callback: null
    }, e),
    this.addScrollListeners = this.addScrollListeners.bind(this),
    this.addClickListener = this.addClickListener.bind(this),
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this),
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this),
    this.destroy = this.destroy.bind(this),
    this.containerElement = document.querySelector(this.settings.container),
    this.paginationElement = document.querySelector(this.settings.pagination),
    this.isLoading = false,
    this.initialize()
};
Ajaxinate.prototype.initialize = function() {
    this.containerElement && {
        click: this.addClickListener,
        scroll: this.addScrollListeners
    }[this.settings.method]()
}
,

Ajaxinate.prototype.addScrollListeners = function() {
    this.paginationElement && (document.addEventListener("scroll", this.checkIfPaginationInView),
    window.addEventListener("resize", this.checkIfPaginationInView),
    window.addEventListener("orientationchange", this.checkIfPaginationInView))
}
,
Ajaxinate.prototype.addClickListener = function() {
    this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.clickActive = !0,
    null !== this.nextPageLinkElement && this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks))
}
,
Ajaxinate.prototype.stopMultipleClicks = function(t) {
    t.preventDefault(),
    this.clickActive && (this.nextPageLinkElement.innerHTML = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.clickActive = !1,
    this.loadMore())
}
,
Ajaxinate.prototype.checkIfPaginationInView = function() {
    // debugger;
    var t = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
    e = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    t <= window.innerHeight && e >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.removeScrollListener(),
    this.nextPageLinkElement && (this.nextPageLinkElement.innerHTML = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.loadMore()));
    // console.log(this.nextPageUrl);
    // console.log(this.paginationElement);
    // console.log(this.nextPageLinkElement.href);
}
,
  Ajaxinate.prototype.loadMore = async function() {
    if (this.isLoading || !this.nextPageUrl) return; // Блокировка дублей
    if ( this.containerElement.children.length == 0 ) return; 
    this.isLoading = true;
    try {
        const response = await fetch(this.nextPageUrl);
        
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(await response.text(), 'text/html');
        
        const containerContent = doc.querySelectorAll(this.settings.container)[0];
        const paginationContent = doc.querySelectorAll(this.settings.pagination)[0];
        
        this.containerElement.insertAdjacentHTML("beforeend", containerContent.innerHTML);
        
        // var api = new Yotpo.API(yotpo);
        // api.refreshWidgets();
        if ( window.initProductCardSliders ) {
            window.initProductCardSliders();
        }
        
        if (!paginationContent) {
            // console.log('hiddenhiddenhidden');
            // debugger;
            document.querySelector('#pagination-wrapper').style.display = 'none';
            window.blockLoadMore = true;
        } else {
            console.log('thatsgreat');
            document.querySelector('#pagination-wrapper').style.display = 'block';
            this.paginationElement.innerHTML = paginationContent.innerHTML;
            
            if (this.settings.callback && typeof this.settings.callback === 'function') {
                this.settings.callback(doc);
            }
            
            this.initialize();
        }
        
    } catch (error) {
        console.error('Ошибка при загрузке:', error);
    } finally {
        this.isLoading = false; // Освобождаем в конце
    }
}
,
Ajaxinate.prototype.removeClickListener = function() {
    if (this.nextPageLinkElement) {
        this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
    }
}
,
Ajaxinate.prototype.removeScrollListener = function() {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
    window.removeEventListener("resize", this.checkIfPaginationInView),
    window.removeEventListener("orientationchange", this.checkIfPaginationInView)
}
,
Ajaxinate.prototype.destroy = function() {
    const deregister = {
        click: this.removeClickListener.bind(this),
        scroll: this.removeScrollListener.bind(this)
    }[this.settings.method];
    
    if (deregister) deregister();
    
    this.nextPageUrl = null; // Очищаем ссылку
    return this;
};
// Функция инициализации наблюдателя
function initAjaxinateObserver() {
    const targetNode = document.querySelector('.product-grid-container');
    // debugger;
    
    if (!targetNode) {
        console.error('Контейнер #product-grid не найден');
        return;
    }

    // Создаем функцию для (пере)запуска Ajaxinate
    const restartAjaxinate = () => {
        
        if ( window.blockLoadMore ) {
            window.blockLoadMore = false;
            return false;
        }
        // 1. Если экземпляр уже существует — полностью его уничтожаем
        if (window.ajaxinateInstance) {
            window.ajaxinateInstance.destroy();
        }

        // 2. Проверяем, есть ли пагинация в DOM
        const pagination = document.querySelector('#pagination-wrapper');
        if (pagination) {
            // Принудительно показываем пагинацию (если она была скрыта на других фильтрах)
            pagination.style.display = 'block';

            // 3. Создаем новый экземпляр
            window.ajaxinateInstance = new Ajaxinate({
                container: '#product-grid',
                pagination: '.infinite_next',
            });
            console.log('Ajaxinate: Перезапуск после фильтрации');

            if ( window.initProductCardSliders ) {
                window.initProductCardSliders();
            }
        }
    };

    // Настраиваем обсервер
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            console.log('sadasdqwesdasdqwesadas');
            // Если в контейнере изменились дочерние элементы (фильтр обновил список)
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                restartAjaxinate();
                break; 
            }
        }
    });

    // Начинаем слежку за контейнером
    observer.observe(targetNode, { childList: true });

    // Первый запуск при загрузке страницы
    restartAjaxinate();
}

document.addEventListener('DOMContentLoaded', initAjaxinateObserver);
